import { defineRoute } from "src/routing/defineRoute";
import { developmentRoute } from "src/routing/domains/developments/detail/developmentDetailPaths";

/**
 * Path + typed URL builder pairs for development overview SideNav leaves.
 *
 * Kept separate from the route tree so `RouteUrls.ts` and pages can import paths without a cycle
 * through page `Component` imports.
 */
export const developmentLotSummaryRoute = defineRoute(`${developmentRoute.path}/lot-summary`);
export const developmentLotSequenceSheetRoute = defineRoute(`${developmentRoute.path}/lot-summary/sequence-sheet`);
export const developmentLotDetailsRoute = defineRoute(
  `${developmentRoute.path}/lot-summary/sequence-sheet/:projectReadyPlanConfigId`,
);
export const developmentLotSiteConditionDetailsRoute = defineRoute(
  `${developmentRoute.path}/lot-summary/sequence-sheet/:projectIdFromSiteCondition`,
);
export const developmentLotSummaryReleaseRoute = defineRoute(`${developmentRoute.path}/lot-summary/release`);
export const developmentDocumentsRoute = defineRoute(`${developmentRoute.path}/documents`);
export const developmentTeamRoute = defineRoute(`${developmentRoute.path}/team`);
export const developmentDropsRoute = defineRoute(`${developmentRoute.path}/drops`);
export const developmentJobLogsRoute = defineRoute(`${developmentRoute.path}/job-logs`);
export const developmentJobLogsGalleryRoute = defineRoute(`${developmentRoute.path}/job-logs/gallery`);
export const developmentJobLogNoteDrawerRoute = defineRoute(
  `${developmentRoute.path}/job-logs/:jobLogId/:jobLogNoteId`,
);
export const developmentAllLotsRoute = defineRoute(`${developmentRoute.path}/cohorts`);
export const developmentDetailLegacyRoute = defineRoute(`${developmentRoute.path}/detail`);
export const developmentLotConfigRoute = defineRoute(`${developmentRoute.path}/lot-config`);
